'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'EventPipe',
    module: requireOrNull('../../../../modules/deal/frontend/event_pipe'),
  },
  {
    name: 'ReloadGIGBindings',
    module: requireOrNull(
      '../../../../modules/deal/frontend/reload_gig_bindings'
    ),
    featureCheck: serverObj => serverObj.isShellContentReq,
  },
  {
    name: 'Carousel',
    module: requireOrNull('../../../../modules/carousel/frontend/desktop'),
    featureCheck: serverObj => serverObj.carousel,
  },
  {
    name: 'StickyPurchaseCluster',
    module: requireOrNull(
      '../../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster'
    ),
    featureCheck: serverObj => serverObj.stickySidebar,
  },
  {
    name: 'Discount',
    module: requireOrNull('../../../../modules/discount/frontend/index'),
  },
  {
    name: 'DealHighlights',
    module: requireOrNull(
      '../../../../modules/deal_highlights/frontend/deal_highlights'
    ),
    featureCheck: serverObj => serverObj.dealHighlights,
  },
  {
    name: 'ShellPageExperiment',
    module: requireOrNull('../../../../modules/deal/shell/frontend/experiment'),
  },
];

const nonCritModules = [
  {
    name: 'DealLazyLoader',
    module: requireOrNull('../../../../modules/deal/frontend/deal_lazy_loader'),
  },
  {
    name: 'Gift',
    module: requireOrNull('../../../../modules/gift_button/frontend/gift'),
  },
  {
    name: 'ChannelTabs',
    module: requireOrNull('../../../../modules/deal/frontend/channel_tabs'),
  },
  {
    name: 'ExternalLinks',
    module: requireOrNull('../../../../modules/deal/frontend/external_links'),
  },
  {
    name: 'ExternalDeal',
    module: requireOrNull(
      '../../../../modules/external_deal/frontend/external_deal'
    ),
    featureCheck: serverObj => serverObj.externalDeal,
  },
  {
    name: 'Sharing',
    module: requireOrNull('../../../../modules/sharing/frontend/facebook'),
  },
  {
    name: 'MemberOnly',
    module: requireOrNull('../../../../modules/member_only/frontend/main'),
    featureCheck: serverObj => serverObj.memberOnly,
  },
  {
    name: 'FixAlly',
    module: requireOrNull('../../scripts/vendor_modules/fix-a11y'),
    featureCheck: serverObj => serverObj.fixA11y,
  },
];

const pageReadyModules = [
  {
    name: 'pageReady',
    module: requireOrNull('../../../../modules/deal/frontend/page_ready'),
  },
];

module.exports = { critModules, nonCritModules, pageReadyModules };
